import React from "react";

import jsPDF from "jspdf";

class Module6PDFGenerator extends React.Component {
  genertatePDF(
    pdfInfo_FirstGrade,
    pdfInfo_SecondGrade,
    pdfInfo_ThirdGrade,
    pdfInfo_FourthGrade,
    pdfInfo_FifthGrade
  ) {
    var doc = new jsPDF("p", "pt");
    var width = doc.internal.pageSize.width;
    var height = doc.internal.pageSize.height;

    var data = require("./pdfData.json");

    //Page1
    doc.addImage(data[0].page1, "png", 0, 0, width, height);

    //Page2
    doc.addPage();
    doc.addImage(data[1].page2, 0, 0, width, height);

    //Page3
    doc.addPage();
    doc.addImage(data[2].page3, 0, 0, width, height);
    if (pdfInfo_FirstGrade != -1) {
      doc.addImage(
        data[5].ratingindex,
        221 + (pdfInfo_FirstGrade - 1) * 69.5,
        207
      );
    }
    if (pdfInfo_SecondGrade != -1) {
      doc.addImage(
        data[5].ratingindex,
        221 + (pdfInfo_SecondGrade - 1) * 69.5,
        254
      );
    }
    if (pdfInfo_ThirdGrade != -1) {
      doc.addImage(
        data[5].ratingindex,
        221 + (pdfInfo_ThirdGrade - 1) * 69.5,
        301
      );
    }
    if (pdfInfo_FourthGrade != -1) {
      doc.addImage(
        data[5].ratingindex,
        221 + (pdfInfo_FourthGrade - 1) * 69.5,
        348
      );
    }
    if (pdfInfo_FifthGrade != -1) {
      doc.addImage(
        data[5].ratingindex,
        221 + (pdfInfo_FifthGrade - 1) * 69.5,
        397
      );
    }

    //Page4
    doc.addPage();
    doc.addImage(data[3].page4, 0, 0, width, height);

    //Page5
    doc.addPage();
    doc.addImage(data[4].page5, 0, 0, width, height);

    doc.save(
      "I have a job, further study place or will be starting my own business.pdf"
    );
  }

  render() {
    return <div></div>;
  }
}

export default Module6PDFGenerator;
